/* eslint-disable security/detect-object-injection */
/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { IAddToCartResources } from '@msdyn365-commerce/components';
import * as React from 'react';
import { Address } from '@msdyn365-commerce/retail-proxy';

//@ts-ignore
import { Error, Alert } from '@churchofjesuschrist/eden-alert';

import {
    IAddressAddItem,
    IAddressAddUpdateProps
} from '@msdyn365-commerce-modules/address/src/modules/account-management-address/../../common/components/address-add';
import { IAccountManagementAddressViewProps } from './lds-my-subscriptions';
import { IAddressError } from '../../modules/lds-checkout-shipping-address/components/address/address-add';
//@ts-ignore
import { Primary, Secondary } from '@churchofjesuschrist/eden-buttons';

import { getCustomerSubscriptionsAsync } from '../../actions/DataActionExtension.g';
import styled from 'styled-components';
import { LoadingSpinner } from '../../components/loading-spinner';
import { AddToCartComponent } from '../../themes/fabrikam/views/components/addtocart.component';

export interface AddressFormProps extends React.Component<IAddressAddUpdateProps> {
    AddressForm: INodeProps;
    heading: React.ReactNode;
    items: IAddressAddItem[];
    hasError: boolean;
    error: IAddressError;
    isShowSaveButton: boolean;
    saveButton: React.ReactNode;
    isShowCancelButton: boolean;
    cancelButton: React.ReactNode;
    isFinalSubmit: boolean;
    getSmarty: any;
    smartyAddress: any;
    final: any;
    inputAddress: any;
    saveAddress: any;
}

/**
 * AddressAddUpdateComponent.
 * @param param0 - Root param.
 * @param param0.AddressForm - Address form.
 * @param param0.heading - Address heading.
 * @param param0.items - IAddressAddItem[].
 * @param param0.hasError - Boolean.
 * @param param0.error - Error message.
 * @param param0.isShowSaveButton - Boolean.
 * @param param0.saveButton - Save button.
 * @param param0.isShowCancelButton - Boolean.
 * @param param0.cancelButton - Cancel button.
 * @returns Address add update component node.
 */
export const AddressAddUpdate: React.FC<any> = props => {
    if (props.smartyAddress) {
        props.smartyAddress.Email = props.inputAddress.Email || props.context.request.User.EmailAddress || '';
    }
    if (props.final) {
        const address2 = props.inputAddress.Street_2 ? props.inputAddress.Street_2 : '';
        return (
            <>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-around' }}>
                    <div>
                        <h3>{props.resources.currentAddressHeader}</h3>
                        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <div>{props.inputAddress.Name}</div>
                            <div>{`${props.inputAddress.Street} ${address2}`}</div>
                            <div>{`${props.inputAddress.City}, ${props.inputAddress.State} ${props.inputAddress.ZipCode}`}</div>
                        </div>
                        <Primary
                            onClick={() => {
                                props.saveAddress(
                                    {
                                        SubscriptionAccountNumber: props.inputAddress.SubscriptionAccountNumber || '',
                                        Name: props.inputAddress.Name || '',
                                        Street: props.inputAddress.Street || '',
                                        City: props.inputAddress.City || '',
                                        State: props.inputAddress.State || '',
                                        ZipCode: props.inputAddress.ZipCode || '',
                                        County: props.inputAddress.County || '',
                                        ThreeLetterISORegionName: props.inputAddress.ThreeLetterISORegionName || '',
                                        StreetNumber: props.inputAddress.StreetNumber || '',
                                        DistrictName: props.inputAddress.DistrictName || '',
                                        BuildingCompliment: props.inputAddress.BuildingCompliment || '',
                                        Email: props.inputAddress.Email || props.context.request.User.EmailAddress || ''
                                    },
                                    false
                                );
                            }}
                        >
                            {props.resources.continueButtonText}
                        </Primary>
                    </div>
                    <div>
                        <h3>{props.resources.newAddressHeader}</h3>
                        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <div>{props.inputAddress.Name}</div>
                            <div>{props.smartyAddress.street}</div>
                            <div>{`${props.smartyAddress.city}, ${props.smartyAddress.state} ${props.smartyAddress.zipcode}`}</div>
                        </div>
                        <Primary
                            onClick={() => {
                                props.saveAddress(props.smartyAddress, true, props.inputAddress.LogisticsLocationRoleRecordId);
                            }}
                        >
                            {props.resources.continueButtonText}
                        </Primary>
                    </div>
                </div>
                <Secondary {...props.cancelButton} onClick={() => props.onCancel()}>
                    {props.resources.addressCancelButtonText}
                </Secondary>
            </>
        );
    } else {
        return (
            <Node {...props.AddressForm}>
                {props.heading}
                {props.items.map((item: IAddressAddItem) => {
                    const { AddressItem, key, label, alert, input } = item;
                    if (input) {
                        // @ts-ignore
                        input.props.id === 'shipping_addressthreeletterisoregionname'
                            ? // @ts-ignore
                              (input.props.additionalAddributes.disabled = true)
                            : null;
                    }
                    return (
                        <Node {...AddressItem} key={key}>
                            {label}
                            {/* @ts-ignore */}
                            {alert && alert.props.message && (
                                <Error style={{ paddingBottom: '5px' }}>
                                    {/* @ts-ignore */}
                                    <div style={{ paddingTop: '5px' }}>{alert.props.message}</div>
                                </Error>
                            )}
                            {/* {alert} */}
                            {input}
                        </Node>
                    );
                })}
                {props.hasError && (
                    <Node {...props.error.AddressError}>
                        {props.error.title}
                        {props.error.message}
                    </Node>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <Primary onClick={() => props.getSmarty()} style={{ width: '40%' }}>
                        {props.resources.continueButtonText}
                    </Primary>
                    <Secondary {...props.cancelButton} onClick={() => props.onCancel()} style={{ width: '40%' }}>
                        {props.resources.addressCancelButtonText}
                    </Secondary>
                </div>
            </Node>
        );
    }
};

/**
 * Account Management Address View Component.
 * @param props - Props.
 * @returns - AccountAddressManagement Module.
 */
const LdsMySubscriptionsView: React.FC<IAccountManagementAddressViewProps> = props => {
    const SubscriptionHeaderOne = styled.div`
        width: 14.28%;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;

        @media (max-width: 775px) {
            width: 25%;
        }
    `;
    const SubscriptionHeaderTwo = styled.div`
        width: 14.28%;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;

        @media (max-width: 775px) {
            display: none;
        }
    `;
    const SubscriptionBodyOne = styled.div`
        width: 14.28%;

        @media (max-width: 775px) {
            width: 25%;
        }
    `;
    const SubscriptionBodyTwo = styled.div`
        width: 14.28%;

        @media (max-width: 775px) {
            display: none;
        }
    `;
    const { AccountAddressManagement, viewState, showAddOrUpdateAddress, screenReaderNotification } = props;
    const [smarty, setSmarty] = React.useState({});
    const [subscriptions, setSubcriptions] = React.useState<any>();
    const [showAddress, setShowAddress] = React.useState<any>();
    const [id, setId] = React.useState<any>();
    const [detailedProductList, setDetailedProductList] = React.useState<any>();
    const [error, setError] = React.useState<any>(false);
    const [doesUserHaveSubs, setDoesUserHaveSubs] = React.useState<boolean>(true);
    const [shouldShow, setShouldShow] = React.useState<boolean>(false);

    const dialogStrings: IAddToCartResources = {
        goToCartText: props.resources.buyBoxGoToCartText,
        continueShoppingText: props.resources.buyBoxContinueShoppingText,
        closeNotificationLabel: props.resources.closeNotificationLabel,
        headerItemOneText: props.resources.buyBoxSingleItemText,
        headerItemFormatText: props.resources.buyBoxMultiLineItemFormatText,
        headerMessageText: props.resources.buyBoxHeaderMessageText,
        freePriceText: props.resources.priceFree,
        originalPriceText: props.resources.originalPriceText,
        currentPriceText: props.resources.currentPriceText,
        addedQuantityText: props.resources.addedQuantityText
    };

    const subscriptionData = async () => {
        const ctx = { callerContext: props.context.actionContext };
        let result;
        if (props.data.accountInformation.result) {
            result = await getCustomerSubscriptionsAsync(ctx, props.data.accountInformation.result.AccountNumber, 'eng');
        } else {
            setDoesUserHaveSubs(false);
        }
        const products: number[] = [];
        if (result) {
            result.map(res => {
                products.push(res.ProductPageRecId);
            });
        } else {
            setDoesUserHaveSubs(false);
        }

        if (products.length >= 1) {
            const productDetailList = await props.getProducts(products);
            setDetailedProductList(productDetailList);
        }
        setSubcriptions(result);

        return true;
    };

    React.useEffect(() => {
        void subscriptionData();
    }, []);
    const showAddressForm = (shouldShowForm: boolean, index: string, address?: Address) => {
        props.editAddress(address);
        setShowAddress({ showForm: shouldShowForm, index: index });
        setId(index);
    };

    const getSmarty = async () => {
        const address = await props.submitAddress(props.context, props.addUpdateAddress);
        setSmarty(address);
    };

    const userCountry = props.data.cart.result.cart.ExtensionProperties?.find((x: any) => x.Key === 'Country')?.Value.StringValue;
    // const addToCart = (item: any, address: Address) => {
    //     if (item.CountryRegionId === userCountry) {
    //         const itemsToAddDetails = detailedProductList.find((product: any) => {
    //             return product.RecordId === item.ProductPageRecId;
    //         });

    //         props.addProductsToCart(props, [itemsToAddDetails], item.SubscriptionAccountNumber, address);
    //     } else {
    //         setError(true);
    //     }
    // };

    const updatedAddress = (address: Address, shouldSave: boolean, roleId?: any) => {
        if (roleId) {
            props.saveAddress(address, shouldSave, roleId);
        } else {
            props.saveAddress(address, shouldSave);
        }
        setShouldShow(true);
    };

    const subscriptionStatus = {
        0: props.resources.activeStatus,
        1: props.resources.suspendedStatus,
        2: props.resources.completedStatus,
        3: props.resources.cancelledStatus
    };

    return (
        <Module {...AccountAddressManagement}>
            <h2>{props.config.heading.text}</h2>
            {error && <Error onClose={() => setError(false)}>{props.resources.subscriptionCheckoutError}</Error>}
            {shouldShow && (
                <Alert onClose={() => setShouldShow(false)}>{props.config.addressUpdate || props.resources.addressUpdate}</Alert>
            )}
            {subscriptions ? (
                !viewState.isShowAddOrUpdateAddress ? (
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                marginBottom: '15px',
                                marginTop: '15px',
                                borderBottom: '1px solid black'
                            }}
                        >
                            <SubscriptionHeaderOne>{props.resources.orderDetailsLabel}</SubscriptionHeaderOne>
                            <SubscriptionHeaderOne>{props.resources.subscriptionLabel}</SubscriptionHeaderOne>
                            <SubscriptionHeaderTwo>{props.resources.subscriptionStatusLabel}</SubscriptionHeaderTwo>
                            <SubscriptionHeaderTwo>{props.resources.subscriptionLanguageLabel}</SubscriptionHeaderTwo>
                            <SubscriptionHeaderTwo>{props.resources.remainingIssuesLabel}</SubscriptionHeaderTwo>
                            <SubscriptionHeaderOne>{props.resources.expirationLabel}</SubscriptionHeaderOne>
                            <SubscriptionHeaderOne>{props.resources.renewLabel}</SubscriptionHeaderOne>
                        </div>
                        {subscriptions.map((subscription: any, index: any) => {
                            const date = new Date(subscription.ExpiryDate);
                            const subscriptionDetails = detailedProductList.find((product: any) => {
                                return product.RecordId === subscription.ProductPageRecId;
                            });
                            const subscriptionLanguage = subscriptionDetails.Dimensions.filter((dimension: any) => {
                                return dimension.DimensionTypeValue === 4;
                            });

                            const subscriptionAddress: any = {
                                SubscriptionAccountNumber: subscription.SubscriptionAccountNumber || '',
                                Name: subscription.SubscriptionName || '',
                                Street: subscription.Street || '',
                                City: subscription.City || '',
                                State: subscription.State || '',
                                ZipCode: subscription.ZipCode || '',
                                Phone: subscription.Phone || '',
                                ThreeLetterISORegionName: subscription.CountryRegionId || '',
                                StreetNumber: subscription.StreetNumber || '',
                                DistrictName: subscription.DistrictName || '',
                                BuildingCompliment: subscription.BuildingCompliment || '',
                                Email: subscription.Email || ''
                            };
                            const indexNum = index === 0 ? 0 : index - 1;

                            return (
                                <div
                                    key={subscription.Id}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        marginBottom: '15px',
                                        borderBottom:
                                            index > 0 && subscriptions[index].CustomerAccount === subscriptions[indexNum].CustomerAccount
                                                ? '1px solid black'
                                                : ''
                                    }}
                                >
                                    {index === 0 ||
                                    (index > 0 && subscriptions[index].CustomerAccount !== subscriptions[indexNum].CustomerAccount) ? (
                                        <SubscriptionBodyOne>
                                            <div>{`#${subscription.SubscriptionAccountNumber}`}</div>
                                            <div>{subscription.SubscriptionName}</div>
                                            <div>{subscription.Street}</div>
                                            <div>{`${subscription.City || ''}${subscription.City ? `,` : ''} ${subscription.State ||
                                                ''} ${subscription.ZipCode || ''}`}</div>
                                            <div>{subscription.CountryRegionId}</div>
                                            <a onClick={() => showAddressForm(true, subscription.Id, subscriptionAddress)}>
                                                {props.resources.subscriptionEditAddressButtonText}
                                            </a>
                                        </SubscriptionBodyOne>
                                    ) : (
                                        <SubscriptionBodyOne></SubscriptionBodyOne>
                                    )}
                                    <SubscriptionBodyOne>
                                        <div>{subscriptionDetails ? subscriptionDetails.Name : subscription.ItemName}</div>
                                    </SubscriptionBodyOne>
                                    <SubscriptionBodyTwo>
                                        <div>{subscriptionStatus[subscription.CPBSubScriptionStatus]}</div>
                                    </SubscriptionBodyTwo>
                                    <SubscriptionBodyTwo>
                                        <div>
                                            {subscriptionDetails && subscriptionLanguage
                                                ? subscriptionLanguage[0].DimensionValue.Value
                                                : subscription.SubscriptionLanguage}
                                        </div>
                                    </SubscriptionBodyTwo>
                                    <SubscriptionBodyTwo>
                                        <div>{subscription.RemainingIssues}</div>
                                    </SubscriptionBodyTwo>
                                    <SubscriptionBodyOne>
                                        <div>{`${new Intl.DateTimeFormat(subscription.SubscriptionLanguage, {
                                            month: 'long'
                                        }).format(date)} ${date.getFullYear()}`}</div>
                                    </SubscriptionBodyOne>

                                    <SubscriptionBodyOne>
                                        {/* <Primary onClick={() => addToCart(subscription, subscriptionAddress)}>
                                            {props.resources.subscriptionAddButtonText}
                                        </Primary> */}
                                        <AddToCartComponent
                                            addToCartText={props.resources.subscriptionAddButtonText}
                                            context={props.context}
                                            id=''
                                            typeName=''
                                            data={{ product: subscriptionDetails, price: subscriptionDetails.Price }}
                                            disabled={false}
                                            hasAvailableProducts={true}
                                            shouldSkipSiteSettings={true}
                                            dialogStrings={dialogStrings}
                                            subscription={subscription}
                                            subscriptionAddress={subscriptionAddress}
                                            subscriptionUserCountry={userCountry}
                                            setSubscriptionError={() => setError(true)}
                                            config={props.config}
                                        />
                                    </SubscriptionBodyOne>
                                </div>
                            );
                        })}
                    </div>
                ) : null
            ) : (
                <>
                    {doesUserHaveSubs && <LoadingSpinner marginBottom={'20px'} marginTop={'20px'} />}
                    {!doesUserHaveSubs && (
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-around' }}>
                            {props.resources.noSubscriptionsFound}
                        </div>
                    )}
                </>
            )}

            {showAddress && viewState.isShowAddOrUpdateAddress && showAddress.showForm && showAddress.index === id ? (
                <AddressAddUpdate
                    {...showAddOrUpdateAddress}
                    isFinalSubmit={props.finalSubmit}
                    getSmarty={getSmarty}
                    smartyAddress={smarty}
                    final={props.finalSubmit}
                    inputAddress={props.addUpdateAddress}
                    saveAddress={updatedAddress}
                    resources={props.resources}
                    onCancel={props.onCancel}
                    context={props.context}
                />
            ) : null}
            {screenReaderNotification}
        </Module>
    );
};

export default LdsMySubscriptionsView;
